import {useMemo} from "react";
import {ScreenType} from "../../config/ScreenConfig";
import {SpeakerType} from "../RoomConfigContext";

export const useSubwoofers = (numWoofers, config, screenType, frontPositions, speakerType) => {
    return useMemo(() => {
        if (numWoofers === 0)
            return [];

        const d = config.size[2] * .5;
        let x;

        if (speakerType === SpeakerType.Waterfall) {
            // needs to be moved by its own size (waterfall are all equally spaced)
            x = -config.size[0];
        }
        else {
            x = frontPositions[0].position[0] - 70;

            // do not intersect with cupboard
            if (screenType === ScreenType.UltraShortThrow) {
                x = Math.max(x, 90);
            }
        }

        const arr =  [{
            position: [ x, 0, -d],
            rotation: Math.PI
        }];

        if (numWoofers === 2)
            arr.push({
                position: [ -x, 0, -d],
                rotation: Math.PI
            });

        return arr;
    }, [config.size, frontPositions, numWoofers, screenType, speakerType]);
}